import { useAutoAnimate } from "@formkit/auto-animate/react"
import React from "react"

interface InputProps {
	props?: any
	className?: string | null
	label?: string | null
	errMsg?: string
	hasError?: boolean
}

const ElemSelect: React.FC<InputProps> = ({ className, props, label, errMsg, hasError, children }) => {
	const [animationRef] = useAutoAnimate<HTMLDivElement>()
	return (
		<label className={"relative block " + (className || "")}>
			<select
				className={
					"placeholder-transparent text-bold text-y peer w-full appearance-none rounded bg-white bg-[url('/src/bgimages/icon-dropdown.png')] bg-[length:20px_25px] bg-[center_left_1rem] bg-no-repeat py-3 px-4 pl-12 text-red shadow-inner outline-0 " +
					(hasError ? "  js-formerror " : "")
				}
				{...props}
			>
				{children}
			</select>
			<div ref={animationRef}>{hasError && <div className="formErrorMsg pt-2 font-bold text-green">{errMsg}</div>}</div>
			<span className={"text-bold  block pt-2 pl-2" + (hasError ? "  text-yellow" : " text-yellow ")}>{label}</span>
		</label>
	)
}

export default ElemSelect
